/**
 * @generated SignedSource<<cca28014ac7d402c72ad35135fcc6836>>
 * @relayHash 81f1628cdf576d210de1d7d090621b40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d890bb6d1941a14035ecebd69c362aacbe5d1248a5a5895d9def8542196cce0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GrowthUnifiedProfileRollingDateIntervalInput = "DAYS_1" | "DAYS_180" | "DAYS_270" | "DAYS_30" | "DAYS_365" | "DAYS_7" | "DAYS_90" | "%future added value";
export type ui_insightsPanelQuery$variables = {
  cloudId: string;
  rollingIntervals: ReadonlyArray<GrowthUnifiedProfileRollingDateIntervalInput>;
};
export type ui_insightsPanelQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"insightsPanel_onboardingHub">;
};
export type ui_insightsPanelQuery = {
  response: ui_insightsPanelQuery$data;
  variables: ui_insightsPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rollingIntervals"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_insightsPanelQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "insightsPanel_onboardingHub"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_insightsPanelQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "tenantId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "GrowthUnifiedProfileSiteProfileResult",
        "kind": "LinkedField",
        "name": "growthUnifiedProfile_siteProfile",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "rollingIntervals",
                "variableName": "rollingIntervals"
              }
            ],
            "concreteType": "GrowthUnifiedProfileSiteOnboardingInsightsResult",
            "kind": "LinkedField",
            "name": "onboardingHubInsightsOverAll",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "totalViews"
              },
              {
                "kind": "ScalarField",
                "name": "totalCompletions"
              },
              {
                "kind": "ScalarField",
                "name": "avgResourceEngagement"
              },
              {
                "kind": "ScalarField",
                "name": "dataSufficiencyPercentage"
              },
              {
                "kind": "ScalarField",
                "name": "availableDataPoints"
              },
              {
                "kind": "ScalarField",
                "name": "rollingInterval"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8d890bb6d1941a14035ecebd69c362aacbe5d1248a5a5895d9def8542196cce0",
    "metadata": {},
    "name": "ui_insightsPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e242f86dfd4a452c15b1d7ed31b2234b";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
